export const bolepidemiologicos2026TNE = [
  {
    "etiqueta_elemento": "Boletín TNE 1er Trimestre 2026",
    "url_elemento":"../../../contenido/epidemiologia/2026/TNE/Boletin 1er Trimestre 2026 TNE.pdf",
  },
  {
    "etiqueta_elemento": "Boletín TNE 2do Trimestre 2026",
    "url_elemento":"../../../contenido/epidemiologia/2026/TNE/Boletin 2do Trimestre 2026 TNE.pdf",
  },
  {
    "etiqueta_elemento": "Boletín TNE 3er Trimestre 2026",
    "url_elemento":"../../../contenido/epidemiologia/2026/TNE/Boletin 3er Trimestre 2026 TNE.pdf",
  },
  // {
  //   "etiqueta_elemento": "4o Informe Trimestral 2026",
  //   "url_elemento":"../../../contenido/epidemiologia/2026/TNE/4o Informe Trimestral 2026 Defectos al Nacimiento.pdf",
  // },
]